/**
 * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  {
    name: 'AppDownloadApk',
    path: '/app-download/apk',
    component: () =>
      import(
        /* webpackChunkName: "AppDownloadApk" */ '@/views/app-download/apk'
      ),
    meta: { title: '下载APP' },
  },
  {
    name: 'AppDownloadPlist',
    path: '/app-download/plist',
    component: () =>
      import(
        /* webpackChunkName: "AppDownloadPlist" */ '@/views/app-download/plist'
      ),
    meta: { title: '下载APP' },
  },
];
